import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { configureGlobalConfig } from './config/globalConfig';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Configure global window variables that were previously injected by Elixir
configureGlobalConfig();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
